export default function() {
  return {
    item: {},
    items: [],
    pagination: {},
    test: {}
  }
}
